import React from 'react';
import { useParams } from 'react-router-dom';
import RoleDetailContent from './RoleDetailContent';

const RoleDetail = () => {
  const { id } = useParams();
  return <RoleDetailContent roleId={id} variant="page" />;
};

export default RoleDetail;
